import request from "../request";
import {
  REACT_BASE_URL_GAMA_SHAREPOINT,
  REACT_BASE_URL_GAMA_VEHICLES,
} from "../url";

export const getVehicles = async (filters, page = 1, query) => {
  const { orderBy = "DESC", orderByProperty = "deviceContract.id" } = query;
  const queryParams = new URLSearchParams(filters).toString();
  return request({
    url:
      `${REACT_BASE_URL_GAMA_VEHICLES}/vehicles/devices/lines?page=${page}&orderBy=${orderBy}&orderByProperty=${orderByProperty}&` +
      queryParams,
    method: "GET",
  });
};

export const getVehicleBrandFilter = async () => {
  return request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/vehicles/brands`,
    method: "GET",
  });
};

export const getVehicleCustomerFilter = async () => {
  return request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/documents/customers`,
    method: "GET",
  });
};

export const getVehicleModelFilter = async () => {
  return request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/vehicles/models`,
    method: "GET",
  });
};

export const getDevicesId = async () => {
  return request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/vehicles/patents`,
    method: "GET",
  });
};

export const getAllDocuments = async (filters, page = 1, query) => {
  const queryParams = new URLSearchParams(filters).toString();
  return request({
    url:
      `${REACT_BASE_URL_GAMA_VEHICLES}/documents/contracts?page=${page}&orderBy=${
        query?.orderBy || "ASC"
      }&orderByProperty=${query?.orderByProperty || "rentId"}&` + queryParams,
    method: "GET",
  });
};

export const getSharepointDoc = async (deviceId, folder) => {
  return request({
    url: `${REACT_BASE_URL_GAMA_SHAREPOINT}/documents/ssm/${deviceId}?list=Vehiculo - Documentos&folder=${folder}`,
    method: "GET",
  });
};

export const downloadDocument = async (fileName, detail) => {
  return request({
    url: `${REACT_BASE_URL_GAMA_SHAREPOINT}/documents/ssm/download?list=Vehiculo - Documentos&folder=${detail}&file=${fileName}`,
    method: "GET",
  });
};

export const exportVehiclesTemplate = async ({ page = 1 }) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/vehicles/export?page=${page}`,
    method: "GET",
  });
};

export const getServices = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/workshops/services`,
    method: "GET",
  });
};
export const getWorkShops = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/workshops/branches`,
    method: "GET",
  });
};

export const getVehiclesCount = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/vehicles/fleet`,
    method: "GET",
  });
};

export const getReportsTypes = async (customer) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/reports/types?customer=${customer}`,
    method: "GET",
  });
};

export const getReportsBrands = async (customer) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/reports/brands?customer=${customer}`,
    method: "GET",
  });
};

export const getReportsTransmissions = async (customer) => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/reports/trasmissions?customer=${customer}`,
    method: "GET",
  });
};

export const getReportsTypesClient = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/reports/types`,
    method: "GET",
  });
};

export const getReportsBrandsClient = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/reports/brands`,
    method: "GET",
  });
};

export const getReportsTransmissionsClient = async () => {
  return await request({
    url: `${REACT_BASE_URL_GAMA_VEHICLES}/reports/trasmissions`,
    method: "GET",
  });
};

export const getServicesQuery = async (query, customerId, filters) => {
  const queryParams = new URLSearchParams(filters).toString();
  return await request({
    url:
      `${REACT_BASE_URL_GAMA_VEHICLES}/workshops/custaccount/${customerId}?orderByProperty=${
        query?.orderByProperty || "OSPADRE"
      }&orderBy=${query?.orderBy || "DESC"}&pageSize=7&page=${
        query?.currentPage || 1
      }&` + queryParams,
    method: "GET",
  });
};
